export interface NavLink {
  label: string;
  to: string;
}

export interface Category {
  id: string;
  name: string;
  desc: string;
}

export interface Testimonial {
  name: string;
  role: string;
  quote: string;
}

export interface Faq {
  q: string;
  a: string;
}

export interface SiteStat {
  value: string;
  label: string;
}

export const brand = {
  name: '揭秘局',
  fullName: '揭秘局 · 独家线报图解门户',
  slogan: '独家线报 · 图解内幕 · 跟进后续',
  intro:
    '揭秘局把散落在各处的线报整理成一条看得懂的脉络：先还原时间线，再用图解和信息图逐项拆解，最后持续跟进后续反映。',
  email: 'contact@jiemiju.news',
  cooperation: 'press@jiemiju.news',
  statement: '本站内容基于公开信息整理与多方交叉核对，涉及个人与机构时以公开可查资料为准。',
  founded: '2021',
};

export const navLinks: NavLink[] = [
  { label: '首页', to: '/' },
  { label: '线报库', to: '/feed' },
  { label: '关于我们', to: '/about' },
];

export const categories: Category[] = [
  { id: 'ent', name: '娱乐线报', desc: '节目生态、选角流程与幕后协作的真实节奏' },
  { id: 'biz', name: '商业内幕', desc: '供应链、代工链路与品牌故事之间的落差' },
  { id: 'tech', name: '科技真相', desc: '发布会参数与真实交付之间的逐项对照' },
  { id: 'fin', name: '财经观察', desc: '分成结构、对赌条款与资金流向的记账方式' },
  { id: 'soc', name: '社会纵深', desc: '城市生活里的排队、补贴与社区生意逻辑' },
  { id: 'opi', name: '文娱舆情', desc: '热梗、矩阵号与内容分发链路的观测记录' },
];

export const stats: SiteStat[] = [
  { value: '1,240+', label: '已还原事件脉络' },
  { value: '3,860', label: '累计图解与信息图' },
  { value: '92%', label: '线报提供者复访率' },
  { value: '24h', label: '热点跟进响应窗口' },
];

export const testimonials: Testimonial[] = [
  {
    name: '林见川',
    role: '内容从业者',
    quote: '以前追热点是一堆截图来回转，现在直接看图解就能理清时间线，省下大量核对工夫。',
  },
  {
    name: '苏念',
    role: '品牌舆情岗',
    quote: '后续反映那一栏是我最常看的，事情过去两周后还能补上进展，很少见到这样的耐心。',
  },
  {
    name: '程越',
    role: '自由撰稿人',
    quote: '信息图把关键数字摊开来讲，引用起来心里有底，不用再去翻十几条动态。',
  },
  {
    name: '何蔓',
    role: '节目策划',
    quote: '他们写选角流程那篇很克制，没有下结论，只把环节摆出来，这点很专业。',
  },
];

export const faqs: Faq[] = [
  {
    q: '揭秘局的线报是从哪里来的？',
    a: '线报主要来自读者投稿、公开资料检索与多方交叉核对。我们会在文中标注信息类型，对无法交叉验证的部分明确标注为"待核实"，不会把单一来源当作结论。',
  },
  {
    q: '为什么很多内容用图解和信息图呈现？',
    a: '事件里最容易被忽略的往往是时间先后和数字关系。把它们画成图之后，读者可以自己判断哪一步是关键，而不是只接受一句结论。',
  },
  {
    q: '后续反映多久更新一次？',
    a: '进入热榜的事件会在 24 小时内跟进首轮进展，之后按周更新，直到事件趋于稳定。旧文会持续回填时间线，链接保持不变。',
  },
  {
    q: '如果我认为某篇内容有误，可以怎么处理？',
    a: '欢迎通过 contact@jiemiju.news 提交更正依据。核实后我们会更新正文，并在文末注明更正时间与内容，不做无痕修改。',
  },
  {
    q: '订阅线报会收到什么？',
    a: '每周一封整理信，包含本周新增的深挖选题、三个最值得看的图解，以及正在跟进但尚未成稿的线索方向。',
  },
];

export const principles: { title: string; desc: string }[] = [
  {
    title: '先还原，再判断',
    desc: '不急着下结论。先把时间线、参与者与数字关系摆清楚，让读者自己看到逻辑链条。',
  },
  {
    title: '信息有出处',
    desc: '每条关键信息都尽量标注来源类型：公开资料、多方交叉、待核实线索，三者分开呈现。',
  },
  {
    title: '持续跟进',
    desc: '热点不是一次性的。事件进入稳定期前，我们会不断回填后续反映，旧文链接始终有效。',
  },
  {
    title: '克制的表达',
    desc: '不煽动情绪，不使用未经证实的指认。涉及个人时保留基本尊重，只讨论可公开讨论的部分。',
  },
];

export const timelineMilestones: { year: string; title: string; desc: string }[] = [
  { year: '2021', title: '从一张便签开始', desc: '三位内容编辑用业余时间整理节目幕后线报，第一张信息图在社交平台被转发上千次。' },
  { year: '2022', title: '建立图解档案', desc: '把零散线报按事件归档，形成可回溯的时间线结构，累计整理图解超过 800 张。' },
  { year: '2023', title: '读者线报通道', desc: '开放读者投稿入口，建立双向核对机制，线报来源从单一渠道扩展为多方交叉。' },
  { year: '2024', title: '跟进机制成型', desc: '上线"后续反映"固定栏目，把热点跟进从一次性报道变成长期档案。' },
  { year: '2026', title: '线报库开放', desc: '把归档内容整理为可检索的线报库，支持按分类与关键词快速定位历史事件。' },
];